var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormattedMessage, injectIntl } from "react-intl";
import React from "react";
import { ApplicationContext } from "../../../../ApplicationContext";
import EditRemarkField from "../details/EditRemarkField";
import Signals from "../../../../signals/Signals";
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
var AssetDetailRemarkField = /** @class */ (function (_super) {
    __extends(AssetDetailRemarkField, _super);
    /**
     *
     * @param props
     */
    function AssetDetailRemarkField(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: [],
            assetModel: _this.props.assetModel
        };
        _this.changeToEditableTextField = _this.changeToEditableTextField.bind(_this);
        _this.render = _this.render.bind(_this);
        return _this;
    }
    /**
     *
     * @return {*}
     */
    AssetDetailRemarkField.prototype.render = function () {
        var assetModel = this.props.assetModel;
        return (React.createElement("div", null,
            React.createElement("hr", null),
            React.createElement("table", { className: "w-100" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { className: "align-bottom font-weight-bold" },
                            React.createElement(FormattedMessage, { id: "asset.detail.label.remark" })),
                        React.createElement("td", null,
                            React.createElement("div", { className: "w-100 d-flex justify-content-end" },
                                React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.changeToEditableTextField },
                                    React.createElement("span", { className: "fe fe-edit-2" }),
                                    " ",
                                    React.createElement(FormattedMessage, { id: "label.generic.update" }))))))),
            React.createElement("div", { className: "mt-3 mb-0" }, assetModel.properties.remark != null ?
                React.createElement("pre", { style: { fontFamily: "inherit", whiteSpace: "pre-wrap" }, onClick: this.changeToEditableTextField }, assetModel.properties.remark)
                : "")));
    };
    AssetDetailRemarkField.prototype.changeToEditableTextField = function () {
        var _this = this;
        var assetModel = this.props.assetModel;
        Signals.ShowOverlay.dispatch(React.createElement(EditRemarkField, { assetModel: assetModel, refreshMethod: function () { _this.setState({ assetModel: assetModel }); } }));
    };
    return AssetDetailRemarkField;
}(React.Component));
AssetDetailRemarkField.contextType = ApplicationContext;
export default injectIntl(AssetDetailRemarkField);
